import React, { useCallback, useEffect, useRef } from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import { sendEvent } from '../../utils';
import StaticImage from '../UI/Image/StaticImage';
import './Rewards.scss';
import CONFIG from '../../config';

interface IRewardsProps {
  context?: IContent;
}

const Rewards = ({
                   context: {
                     rewards: {
                       title,
                       description,
                       cta: { type, content, link, tracking },
                       image
                     }
                   }
                 }: IRewardsProps) => {
  const containerRef = useRef<HTMLDivElement>();

  useEffect(() => {
    if (!CONFIG.isUPC) {
      containerRef.current.className = 'linear-gradient';
    } else {
      containerRef.current.className = 'no-background';
    }
  }, []);

  const sendTrackingEvent = useCallback(() => {
    sendEvent(tracking);
  }, [tracking]);

  console.log(link)

  return (
    <div ref={containerRef}>
      <div className='wallet-container rewards no-display-mobile'>
        <div className='rewards__image-container'>
          <StaticImage imageName={image} extension='png' altText='' />
        </div>
        <div className='rewards__content'>
          <h2 className='rewards__content__title' dangerouslySetInnerHTML={{ __html: title }} />
          <div className='rewards__content__subtitle'>{description}</div>
          <a
            href={link}
            className={`tablet-n-up btn btn__${type}`}
            data-alt-text={content}
            onClick={() => sendTrackingEvent()}
          >
            <span>{content}</span>
          </a>
        </div>
        <div className='cta-wrapper'>
          <a
            href={link}
            className={`mobile-only btn btn__${type}`}
            data-alt-text={content}
            onClick={() => sendTrackingEvent()}
          >
            <span>{content}</span>
          </a>
        </div>
      </div>
      <div className='rewards mobile-only'>
        <div className='rewards__content'>
          <h2 className='rewards__content__title' dangerouslySetInnerHTML={{ __html: title }} />
          <div className='rewards__content__subtitle'>{description}</div>
          <a
            href={link}
            className={`tablet-n-up btn btn__${type}`}
            data-alt-text={content}
            onClick={() => sendTrackingEvent()}
          >
            <span>{content}</span>
          </a>
        </div>
        <div className='rewards__image-container'>
          <StaticImage imageName={image} extension='png' altText='' />
        </div>
        <div className='cta-wrapper'>
          <a
            href={link}
            className={`mobile-only btn btn__${type}`}
            data-alt-text={content}
            onClick={() => sendTrackingEvent()}
          >
            <span>{content}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default withContent(Rewards);